
<div>
    <app-bar :title="t('complaints_title')"></app-bar>

    <v-layout>
        <complaint-collection></complaint-collection>
    </v-layout>
</div>
